/* eslint-disable xss/no-mixed-html */
/* eslint-disable xss/no-location-href-assign */
/* eslint-disable complexity */
/* eslint-disable sonarjs/no-identical-functions */
ACC.focproduct = {
  hideCls: 'hidden',
  overlayCls: '.ph-popup_overlay',
  showFOCpproductPopup: function() {
    $.colorbox({
      maxWidth: '500px',
      width: '95%',
      height: 'auto',
      scrolling: true,
      html: $('.ph-focProduct_popup').html(),
      escKey: false,
      overlayClose: false,
      onLoad: function() {
        $('#cboxClose').remove();
      },
      onClosed: function() {
        ACC.common.refreshScreenReaderBuffer();
      }
    });
  },
  addProductsFromCookieToCart: function(productList) {
    $.ajax({
      url: ACC.config.encodedContextPath + '/cart/add/multiple',
      data: {
        products: productList.toString()
      },
      type: 'POST',
      Datatype: 'json',
      success: function(cartResult) {
        if (cartResult.coupon && cartResult.coupon === 'true') {
          window.location.href = ACC.config.encodedContextPath + '/coupon';
        } else if (cartResult.checkout && cartResult.checkout === 'true') {
          window.location.href = ACC.config.encodedContextPath + '/checkout/single';
        }
      }
    });
  },
  validateFOCCouponField: function(val) {
    if (val.toString() !== '') {
      return true;
    }

    return false;
  },
  loadStockCheckForFOC: function(resultList) {
    var $plRowEl = $('#ph-foc_prod_' + resultList.code),
        allAvailDataCount = 0,
        outOfStockDataCount = 0,
        partialProdOutError = '.ph-partialProdOutError',
        allProdOutError = '.ph-allProdOutError',
        addFocProductcart = '.ph-addFocProductcart',
        hideCls = 'hidden';

    $plRowEl.attr('data-availability', resultList.atpData.availabilityCode);

    if ($('.pageLabel-newHomePage').length > 0) {
      allAvailDataCount = $('.ph-focProduct_popup .ph-focProduct_row[data-availability]').length;
      outOfStockDataCount = $('.ph-focProduct_popup .ph-focProduct_row[data-availability=red]').length;
    } else if ($('.pageLabel-couponPage').length > 0) {
      allAvailDataCount = $('.ph-coupon_availableProd .ph-focProduct_row[data-availability]').length;
      outOfStockDataCount = $('.ph-coupon_availableProd .ph-focProduct_row[data-availability=red]').length;
    }

    if (allAvailDataCount === outOfStockDataCount) {
      $(partialProdOutError).addClass(hideCls);
      $(allProdOutError).removeClass(hideCls);
      $(addFocProductcart).addClass('ph-disable-button');
    } else if (allAvailDataCount > outOfStockDataCount && outOfStockDataCount !== 0) {
      $(allProdOutError).addClass(hideCls);
      $(partialProdOutError).removeClass(hideCls);
      $(addFocProductcart).removeClass('ph-disable-button');
    } else if (outOfStockDataCount === 0) {
      $(allProdOutError).addClass(hideCls);
      $(partialProdOutError).addClass(hideCls);
      $(addFocProductcart).removeClass('ph-disable-button');
    }

    $.colorbox.resize();
    $('.ph-popup_overlay').addClass(hideCls);
  }
};
$(document).ready(function() {
  var storeClosed = $('.ph-storeclosed').val(),
      listProdSize = $('.ph-listProdSize').val(),
      isFocProductExists = localStorage.getItem('focProductHasBeenDisplayed'),
      cartExist = $('.ph-cartExist').val(),
      allowFocProd = $('.ph-isFOCAllowed').val(),
      couponToggle = $('.ph-isCouponPageEnabled').val(),
      prodCodes = [];

  if ($('.pageLabel-newHomePage').length > 0 || $('.pageLabel-couponPage').length > 0) {
    if ($('.ph-focProduct_row').length > 0) {
      $('.ph-popup_overlay').removeClass('hidden');
      $('.ph-focProduct_row').each(function(index, item) {
        var prodCode = $(item).attr('id').split('ph-foc_prod_');

        if (prodCode) {
          prodCodes.push(prodCode[1]);
        }
      });

      if (prodCodes.length !== 0) {
        /* eslint-disable vars-on-top */
        for (var prdIdx = 0; prdIdx < prodCodes.length; prdIdx = prdIdx + 1) {
          /* eslint-enable vars-on-top */
          ACC.common.getAtpData(prodCodes[prdIdx], function(result) {
            if (result) {
              ACC.focproduct.loadStockCheckForFOC(result);
            }
          });
        }
      }
    }
  }

  $(document).on('click', '.ph-addFocProductcart', function() {
    var productListFoc = [],
        propEleFromPage = '';

    if (allowFocProd === 'false') {
      $.colorbox({
        maxWidth: '630px',
        width: '95%',
        height: 'auto',
        scrolling: true,
        html: $('.ph-createswitchpopup').html(),
        onClosed: function() {
          ACC.common.refreshScreenReaderBuffer();
        }
      });
    } else {
      productListFoc.push('FocProduct_AddToCartAction');

      if ($('.pageLabel-newHomePage').length > 0) {
        propEleFromPage = '.ph-focProduct_popup .ph-focProduct_row';
      } else if ($('.pageLabel-couponPage').length > 0) {
        propEleFromPage = '.ph-coupon_availableProd .ph-focProduct_row';
      }

      $(propEleFromPage).not('[data-availability="red"]').each(function() {
        var prodVal = $(this).attr('data-prodcode'),
            qtyVal = 1;

        productListFoc.push(prodVal + ':' + qtyVal);
      });
      $(ACC.focproduct.overlayCls).removeClass(ACC.focproduct.hideCls);
      ACC.focproduct.addProductsFromCookieToCart(productListFoc);
      $.colorbox.close();

      if ($('.ph-popup_overlay').is(':visible')) {
        $('.ph-support-contact-details-default').css('z-index', 3);
      }
    }
  });

  $(document).on('click', '.ph-proceed_foc', function() {
    var productListFoc = [],
        propEleFromPage = '';

    productListFoc.push('FocProduct_AddToCartAction');

    if ($('.pageLabel-newHomePage').length > 0) {
      propEleFromPage = '.ph-focProduct_popup .ph-focProduct_row';
    } else if ($('.pageLabel-couponPage').length > 0) {
      propEleFromPage = '.ph-coupon_availableProd .ph-focProduct_row';
    }

    $(propEleFromPage).not('[data-availability="red"]').each(function() {
      var prodVal = $(this).attr('data-prodcode'),
          qtyVal = 1;

      productListFoc.push(prodVal + ':' + qtyVal);
    });
    $(ACC.focproduct.overlayCls).removeClass(ACC.focproduct.hideCls);
    ACC.focproduct.addProductsFromCookieToCart(productListFoc);
    $.colorbox.close();

    if ($('.ph-popup_overlay').is(':visible')) {
      $('.ph-support-contact-details-default').css('z-index', 3);
    }
  });

  $(document).on('click', '.ph-cancelcart, .ph-closefocpopup, .ph-cancel_foc', function() {
    $.colorbox.close();
  });

  $(document).on('click', '.ph-confirmbackto_foc', function() {
    var navUrl = $(this).attr('data-navurl');

    $.ajax({
      url: ACC.config.encodedContextPath + '/cart/clear-foc-cart',
      type: 'POST',
      datatype: 'json',
      success: function() {
        $.colorbox.close();

        if (navUrl === '/coupon' || navUrl === 'search') {
          window.location.href = ACC.config.encodedContextPath + '/coupon';
        } else {
          window.location = navUrl;
        }
      },
      error: function() {
        $('.ph-RemoveProduct').html('');
        $.colorbox.close();
      }
    });
  });

  $(document).on('click', '.ph-backtocart_foc', function() {
    $.colorbox({
      width: '500px',
      maxWidth: '90%',
      height: '200px',
      html: $('.ph-CancelFOCPopup').html(),
      overlayClose: false,
      onComplete: function() {
        $('#cboxContent .ph-confirmbackto_foc').attr('data-navurl', '/coupon');
      },
      onClosed: function() {
        ACC.common.refreshScreenReaderBuffer();
      }
    });
  });

  if ($('.pageLabel-newHomePage').length > 0) {
    if (listProdSize > 0 && isFocProductExists === null && cartExist !== 'true' &&
$('.ph-sap-orderBlock').length === 0 && storeClosed !== 'true' && couponToggle === 'true') {
      ACC.focproduct.showFOCpproductPopup();
      localStorage.setItem('focProductHasBeenDisplayed', 'true');
    }
  }

  if ($('.pageLabel-login').length > 0) {
    localStorage.removeItem('focProductHasBeenDisplayed');
  }

  $(document).on('click', '#ph-verify-foc-coupon-btn', function() {
    var $couponCodeInp = $('#ph-redeemCode');
    var emptyErrMsg = '';
    var flag = ACC.focproduct.validateFOCCouponField($couponCodeInp.val());

    if (flag === false) {
      emptyErrMsg = $couponCodeInp.closest('.ph-redeemCode.ph-inputData').attr('data-emptycontent');
      $couponCodeInp.closest('.ph-signup__error').addClass('form_field_error ph-form_field_error');
      $couponCodeInp.closest('.ph-signup__error').find('.ph-coupon__emptyvalue').text(emptyErrMsg);
    } else {
      $couponCodeInp.closest('.ph-signup__error').removeClass('form_field_error ph-form_field_error');
      $couponCodeInp.closest('.ph-signup__error').find('.ph-coupon__emptyvalue').text('');
      $.ajax({
        url: ACC.config.encodedContextPath + '/coupon/voucherVerification/validate-voucher-code',
        data: {
          voucherCode: encodeURIComponent($couponCodeInp.val())
        },
        type: 'POST',
        Datatype: 'json',
        success: function() {
          window.location.reload();
        }
      });
    }
  });
});
/* eslint-enable xss/no-location-href-assign */
/* eslint-enable xss/no-mixed-html */
/* eslint-enable complexity */
/* eslint-enable sonarjs/no-identical-functions */
